<template>
   <div class="action-top-wrapper">
      <div class="header">
         <div>
            <div>{{ title }}</div>
            <div style="font-weight: normal; font-size: 0.9em;">{{ subTitle }}</div>
         </div>
         <div class='action-btns'>
            <small>Add</small>
            <el-button
               size="mini"
               @click="$emit('add-row')"
               icon="el-icon-plus"
               content="Add row"
               v-tippy
               circle
            />
         </div>
      </div>
      <el-table :data="data">
         <el-table-column label="Actions" fixed="right" width="100">
            <template slot-scope="scope">
               <el-button
                  @click="$emit('edit-row', scope)"
                  size="mini"
                  icon="el-icon-edit"
                  style="margin-right: 2px;"
                  circle
                  content="Edit"
                  v-tippy
               />
               <el-button
                  @click="$emit('delete-row', scope)"
                  size="mini"
                  icon="el-icon-delete"
                  content="Delete"
                  v-tippy
                  circle
               />
            </template>
         </el-table-column>
         <el-table-column
            v-for="{label, prop, width} in columnDefs"
            :key="prop"
            :prop="prop"
            :width="width"
            :label="label"
         />
      </el-table>
   </div>
</template>

<script>
import {Button, Table, TableColumn} from 'element-ui';
/*
props:
   title, subTitle, data, columnDefs
events:
   add-row
   edit-row
   delete-row
*/
export default {
   name: 'DataTable',
   components: {
      'el-button': Button,
      'el-table': Table,
      'el-table-column': TableColumn,
   },
   props: {
      title: {
         type: String,
         required: true,
      },
      subTitle: {
         type: String,
         default: '',
      },
      data: {
         type: Array,
         required: true,
      },
      columnDefs: {
         type: Array,
         required: true,
         // columnDefs can't be an empty list
         // definitions must have prop and label 
         validator: value => value.length && value.every(item => item.prop && item.label),
      },
   },
   methods: {

   }
}
</script>

<style lang="scss" scoped>
.header {
   display: flex;
   justify-content: space-between;
}
</style>
